import { useEffect } from "react"
import { useAppDispatch } from "./app/hooks"

import "./i18n/i18n"
import { useTranslation } from "react-i18next"

import { setConfig } from "./features/config/configSlice"

import { OpenPositions } from "./features/openPositions/OpenPositions"
import { Search } from "./features/search/Search"

import { Config } from "./types"

import { LayoutMain } from "./layouts/layoutMain/LayoutMain"

type Props = {
  options?: Config
}

function App({ options }: Props) {
  const dispatch = useAppDispatch()
  const { i18n } = useTranslation()

  useEffect(() => {
    dispatch(setConfig(options))
  }, [dispatch, options])

  useEffect(() => {
    if (options?.language) {
      i18n.changeLanguage(options.language)
    }
  }, [i18n, options?.language])

  return (
    <LayoutMain>
      <Search />
      <OpenPositions />
    </LayoutMain>
  )
}

export default App
